import { engineComponent } from "neo-common";
import { SwitchElement } from "../Components/Elements/Graphics/SwitchElement";
import { ComponentTypes } from "../Components/ComponentTypes";
import { ContainerElement } from "../Components/Elements/Graphics/ContainerElement";

/**
 * The payline element is used for hold payline special cases and handle payline behaviour on screen.
 * @class Symbol
 * @extends SwitchElement
 */
@engineComponent(ComponentTypes.DisplayObject)
export class Payline extends SwitchElement {
    //special payline cases
    static CaseNormal: string = "NORMAL";
    static CaseShow: string = "SHOW";
    static CaseNowin: string = "NOWIN";
    static CaseWin: string = "WIN";
    static CaseFirstWin: string = "FIRST_WIN";
    static CaseSingleWin: string = "SINGLE_WIN";
    static CaseSelect: string = "SELECT";
    static CaseCycle: string = "CYCLE";

    public addTopContainer(cnt: ContainerElement): void {
        if (this.elements.childs["NumberBackgroundLeft"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundLeft"]);
        if (this.elements.childs["NumberBackgroundRight"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundRight"]);
        if (this.elements.childs["NumberBackgroundLeftB0"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundLeftB0"]);
        if (this.elements.childs["NumberBackgroundRightB0"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundRightB0"]);
        if (this.elements.childs["NumberBackgroundLeftB"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundLeftB"]);
        if (this.elements.childs["NumberBackgroundRightB"] != null)
            cnt.addChild(this.elements.childs["NumberBackgroundRightB"]);
        if (this.elements.childs["NumberLeft"] != null) cnt.addChild(this.elements.childs["NumberLeft"]);
        if (this.elements.childs["NumberRight"] != null) cnt.addChild(this.elements.childs["NumberRight"]);
    }
}



/** WEBPACK FOOTER **
 ** ./Engine/Game/GameComponents/Payline.ts
 **/